import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as Check } from 'assets/icons/ball-check-icon.svg';
import { ReactComponent as Failed } from 'assets/icons/actions-status/decline-action.svg';

interface StatusHistoryRowProps {
  label: string;
  labelClassName?: string;
  standardLabelClassName?: string;
  time?: string | null;
  index: number;
  hasNoInStandard: boolean;
  isLast: boolean;
}

const StatusHistoryRow: React.FC<StatusHistoryRowProps> = ({
  label,
  labelClassName,
  standardLabelClassName,
  time,
  index,
  isLast,
  hasNoInStandard,
}) => {
  return (
    <div className="w-[370px] flex">
      <div className="flex flex-col items-center mr-2.5">
        <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
          {hasNoInStandard && <Failed className="w-6 h-6" />}
          {!hasNoInStandard &&
            (time ? (
              <Check className="w-6 h-6" />
            ) : (
              <span className="flex items-center justify-center rounded-full text-white font-bold text-xs w-6 h-6 bg-[#B0B0B0]">
                {String(index + 1).padStart(2, '0')}
              </span>
            ))}
        </div>
        {!isLast && (
          <div className="w-[2px] bg-[#B0B0B0] -mb-5 flex-grow my-1 min-h-[24px]" />
        )}
      </div>
      <div className="flex flex-1 items-start pt-0.5">
        <span
          className={twMerge(
            'border-[#B0B0B0] bg-black/5 desktop:text-[#B0B0B0] rounded-xl px-2.5 font-bold text-h7 whitespace-nowrap',
            standardLabelClassName,
            labelClassName,
          )}
        >
          {label}
        </span>
        {time && (
          <span className="font-medium text-med-gray-3 ml-auto">{time}</span>
        )}
      </div>
    </div>
  );
};

export default StatusHistoryRow;
